import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcDropdownComponent } from './fc-dropdown.component';

const components = [FcDropdownComponent];
@NgModule({
    imports: [CommonModule],
    declarations: components,
    exports: components
})
export class FcDropdownModule {}
